// Transport types configuration
export const TRANSPORT_TYPES = {
  plane: {
    id: 'plane',
    icon: 'Plane',
    label: { 'pt-BR': 'Avião', 'en-US': 'Airplane' },
    color: 'sky'
  },
  car: {
    id: 'car',
    icon: 'Car',
    label: { 'pt-BR': 'Carro próprio', 'en-US': 'Own car' },
    color: 'green'
  },
  bus: {
    id: 'bus',
    icon: 'Bus',
    label: { 'pt-BR': 'Ônibus', 'en-US': 'Bus' },
    color: 'orange'
  },
  van: {
    id: 'van',
    icon: 'Truck',
    label: { 'pt-BR': 'Van/Carona', 'en-US': 'Van/Carpool' },
    color: 'purple'
  },
  train: {
    id: 'train',
    icon: 'Train',
    label: { 'pt-BR': 'Trem', 'en-US': 'Train' },
    color: 'red'
  },
  motorcycle: {
    id: 'motorcycle',
    icon: 'Bike',
    label: { 'pt-BR': 'Moto', 'en-US': 'Motorcycle' },
    color: 'yellow'
  },
  boat: {
    id: 'boat',
    icon: 'Ship',
    label: { 'pt-BR': 'Barco/Navio', 'en-US': 'Boat/Ship' },
    color: 'cyan'
  },
  other: {
    id: 'other',
    icon: 'CircleDot',
    label: { 'pt-BR': 'Outro', 'en-US': 'Other' },
    color: 'slate'
  }
};

// Relationship options for dependents
export const RELATIONSHIP_OPTIONS = [
  { value: 'filho', label: { 'pt-BR': 'Filho(a)', 'en-US': 'Son/Daughter' } },
  { value: 'sobrinho', label: { 'pt-BR': 'Sobrinho(a)', 'en-US': 'Nephew/Niece' } },
  { value: 'neto', label: { 'pt-BR': 'Neto(a)', 'en-US': 'Grandchild' } },
  { value: 'irmao', label: { 'pt-BR': 'Irmão(ã)', 'en-US': 'Sibling' } },
  { value: 'primo', label: { 'pt-BR': 'Primo(a)', 'en-US': 'Cousin' } },
  { value: 'amigo', label: { 'pt-BR': 'Amigo(a)', 'en-US': 'Friend' } },
  { value: 'conjuge', label: { 'pt-BR': 'Cônjuge', 'en-US': 'Spouse' } },
  { value: 'outro', label: { 'pt-BR': 'Outro', 'en-US': 'Other' } },
];

// Status colors for dependents
export const DEPENDENT_STATUS = {
  pending: {
    label: { 'pt-BR': 'Aguardando aprovação', 'en-US': 'Pending approval' },
    color: 'yellow',
    bgClass: 'bg-yellow-100 dark:bg-yellow-900/30',
    textClass: 'text-yellow-700 dark:text-yellow-300'
  },
  approved: {
    label: { 'pt-BR': 'Aprovado', 'en-US': 'Approved' },
    color: 'green',
    bgClass: 'bg-green-100 dark:bg-green-900/30',
    textClass: 'text-green-700 dark:text-green-300'
  },
  rejected: {
    label: { 'pt-BR': 'Recusado', 'en-US': 'Rejected' },
    color: 'red',
    bgClass: 'bg-red-100 dark:bg-red-900/30',
    textClass: 'text-red-700 dark:text-red-300'
  }
};
